import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export type WizardExitDialogResult = 'cancel' | 'delete' | 'save';

@Component({
  standalone: false,
  selector: 'app-wizard-exit-dialog',
  templateUrl: 'wizard-exit-dialog.component.html',
  styleUrls: ['wizard-exit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class WizardExitDialogComponent {

  constructor(private dialogRef: MatDialogRef<WizardExitDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close('cancel' as WizardExitDialogResult);
  }

  onDelete(): void {
    this.dialogRef.close('delete' as WizardExitDialogResult);
  }

  onSave(): void {
    this.dialogRef.close('save' as WizardExitDialogResult);
  }
}
